// Wallet Feature Constants for Rapidoo V3

export const EVENTS = {
  WALLET: {
    // Events existants (compatibilité)
    REFRESH: 'wallet.refresh',
    REFRESHING: 'wallet.refreshing',
    REFRESH_ERROR: 'wallet.error',
    REFRESHED: 'wallet.refreshed',

    // Nouveaux événements V3
    // Balance events
    BALANCE_LOAD: 'WALLET.BALANCE_LOAD',
    BALANCE_UPDATE: 'WALLET.BALANCE_UPDATE',
    BALANCE_ERROR: 'WALLET.BALANCE_ERROR',

    // Deposit events
    DEPOSIT_OPEN: 'WALLET.DEPOSIT_OPEN',
    DEPOSIT_INITIATE: 'WALLET.DEPOSIT_INITIATE',
    DEPOSIT_POLLING_START: 'WALLET.DEPOSIT_POLLING_START',
    DEPOSIT_POLLING_UPDATE: 'WALLET.DEPOSIT_POLLING_UPDATE',
    DEPOSIT_POLLING_STOP: 'WALLET.DEPOSIT_POLLING_STOP',
    DEPOSIT_SUCCESS: 'WALLET.DEPOSIT_SUCCESS',
    DEPOSIT_ERROR: 'WALLET.DEPOSIT_ERROR',

    // Withdrawal events
    WITHDRAWAL_OPEN: 'WALLET.WITHDRAWAL_OPEN',
    WITHDRAWAL_INITIATE: 'WALLET.WITHDRAWAL_INITIATE',
    WITHDRAWAL_SUCCESS: 'WALLET.WITHDRAWAL_SUCCESS',
    WITHDRAWAL_ERROR: 'WALLET.WITHDRAWAL_ERROR',

    // Transaction events
    TRANSACTIONS_LOAD: 'WALLET.TRANSACTIONS_LOAD',
    TRANSACTIONS_UPDATE: 'WALLET.TRANSACTIONS_UPDATE',
    TRANSACTIONS_ERROR: 'WALLET.TRANSACTIONS_ERROR',

    // Account events
    ACCOUNTS_LOAD: 'WALLET.ACCOUNTS_LOAD',
    ACCOUNTS_UPDATE: 'WALLET.ACCOUNTS_UPDATE',
    ACCOUNTS_ERROR: 'WALLET.ACCOUNTS_ERROR',
    ACCOUNT_CREATE: 'WALLET.ACCOUNT_CREATE',
    ACCOUNT_CREATED: 'WALLET.ACCOUNT_CREATED',
    ACCOUNT_CREATE_ERROR: 'WALLET.ACCOUNT_CREATE_ERROR',
    ACCOUNT_MODAL_OPEN: 'WALLET.ACCOUNT_MODAL_OPEN',
    ACCOUNT_MODAL_CLOSE: 'WALLET.ACCOUNT_MODAL_CLOSE',

    // UI events
    MODAL_OPEN: 'WALLET.MODAL_OPEN',
    MODAL_CLOSE: 'WALLET.MODAL_CLOSE'
  }
};

// Wallet status constants
export const WALLET_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  PROCESSING: 'processing'
};

// Transaction types
export const WALLET_TRANSACTION_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit'
};

// Payment methods
export const WALLET_PAYMENT_METHODS = {
  MOOV: 'moov',
  MTN: 'mtn',
  CARD: 'card',
  WALLET: 'wallet'
};

// FedaPay transaction statuses
export const FEDAPAY_TRANSACTION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  TRANSFERRED: 'transferred',
  CANCELLED: 'cancelled'
};

// Polling configuration
export const WALLET_POLLING_CONFIG = {
  MAX_ATTEMPTS: 30,
  INTERVAL_MS: 2000,
  BACKOFF_MULTIPLIER: 1.5,
  MAX_INTERVAL_MS: 10000
};

// Wallet limits
export const WALLET_LIMITS = {
  MIN_DEPOSIT: 500,
  MAX_DEPOSIT: 500000,
  MAX_WITHDRAWAL: 200000,
  DAILY_WITHDRAWAL_LIMIT: 500000,
  ZERO_AMOUNT_TOLERANCE: 0
};

// API Endpoints
export const ENDPOINTS = {
  WALLET: {
    BALANCE: 'https://api.monrapidoo.com/wallet/balance/wallet_{userId}?service=rapidoo&country=ANY&processor=rapidoWallet&currency=XOF&group=ultraxeno',
    FUNDING: 'https://api.monrapidoo.com/queue/broadcast/data/rapidoo-transactions/fundingWalletRequested?group=commons',
    WITHDRAWAL: 'https://api.monrapidoo.com/queue/broadcast/data/rapidoo-transactions/withdrawalRequested?group=commons',
    // On utilise l'API en direct
    TRANSACTIONS: 'https://api.monrapidoo.com/rapidoo-transactions/list?group=ultraxeno',
    // Withdrawal Accounts endpoints
    ACCOUNTS_LIST: 'https://api.monrapidoo.com/accounts/list?service=rapidoo&group=ultraxeno',
    ACCOUNT_CREATE: 'https://api.monrapidoo.com/accounts/create?service=rapidoo&group=ultraxeno',
    ACCOUNT_UPDATE: 'https://api.monrapidoo.com/accounts/update/{id}?service=rapidoo&group=ultraxeno'
  }
};

// Error codes
export const WALLET_ERROR_CODES = {
  INSUFFICIENT_BALANCE: 'WALLET_ERR_001',
  INVALID_AMOUNT: 'WALLET_ERR_002',
  PAYMENT_FAILED: 'WALLET_ERR_003',
  PAYMENT_TIMEOUT: 'WALLET_ERR_004',
  TRANSACTION_NOT_FOUND: 'WALLET_ERR_005',
  WITHDRAWAL_LIMIT_EXCEEDED: 'WALLET_ERR_006',
  DAILY_LIMIT_EXCEEDED: 'WALLET_ERR_007',
  INVALID_PHONE_NUMBER: 'WALLET_ERR_008',
  WALLET_NOT_FOUND: 'WALLET_ERR_009',
  NETWORK_ERROR: 'WALLET_ERR_010'
};

// Wallet currencies
export const WALLET_CURRENCIES = {
  XOF: 'XOF', // West African CFA franc
  EUR: 'EUR',
  USD: 'USD'
};

// Default currency
export const WALLET_DEFAULT_CURRENCY = WALLET_CURRENCIES.XOF;

// Transaction filters
export const TRANSACTION_FILTERS = {
  ALL: 'all',
  CREDIT: 'credit',
  DEBIT: 'debit',
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100
};

export default {
  EVENTS,
  WALLET_STATUS,
  WALLET_TRANSACTION_TYPES,
  WALLET_PAYMENT_METHODS,
  FEDAPAY_TRANSACTION_STATUS,
  WALLET_POLLING_CONFIG,
  WALLET_LIMITS,
  ENDPOINTS,
  WALLET_ERROR_CODES,
  WALLET_CURRENCIES,
  WALLET_DEFAULT_CURRENCY,
  TRANSACTION_FILTERS,
  PAGINATION
};
